export function ConfidenceMeter({ value = 0, label = true, size = "md" }) {
  const v = Math.max(0, Math.min(100, Math.round(value)));
  const color = v >= 75 ? "#007AFF" : v >= 45 ? "#FFB020" : "#FF3B30";
  const h = size === "sm" ? "h-1" : "h-1.5";
  return (
    <div className="flex items-center gap-2 w-full" data-testid="confidence-meter">
      <div className={`flex-1 ${h} bg-white/8 rounded-sm overflow-hidden`}>
        <div className={`${h} rounded-sm transition-[width] duration-700`} style={{ width: `${v}%`, background: color }} />
      </div>
      {label && (
        <span className="font-mono text-[11px] tabular-nums" style={{ color }}>{v}%</span>
      )}
    </div>
  );
}
